<svg xmlns="http://www.w3.org/2000/svg" [ngClass]="'icon ' + iconCls" viewBox="0 0 50 50.671">
	<path
		class="icon__path"
		d="M458.617,64.837,441.006,30.763c-3.339-6.462-8.8-6.462-12.138,0L411.256,64.837c-3.339,6.466-.119,11.751,7.153,11.751h33.055C458.736,76.588,461.956,71.3,458.617,64.837ZM431,41.2a3.554,3.554,0,0,1,2.754-.975h2.36a3.542,3.542,0,0,1,2.75.975,3.48,3.48,0,0,1,.975,2.724l-.7,9.632a4.215,4.215,0,0,1-8.406-.036l-.7-9.589A3.5,3.5,0,0,1,431,41.2Zm3.934,29.426A4.958,4.958,0,1,1,439.9,65.67,4.958,4.958,0,0,1,434.937,70.628Z"
		transform="translate(-409.937 -25.917)"
	/>
</svg>
